/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import styled from 'styled-components/macro';
import Heading from 'components/atoms/Heading';
import Link from 'components/atoms/Link';

import MailIcon from 'assets/images/readed-mail.svg';
import { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Button from 'components/atoms/Button';
import Logo from 'components/atoms/Logo';
import Paragraph from 'components/atoms/Paragraph';
import userService from 'services/userService';
import Toast from 'components/molecules/Toast';
import { AuthContext } from 'context/authContext';

export const IconHolder = styled.div`
  width: 100px;
  height: 100px;
  background: var(--bg-dark);
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 30px auto 30px;
  @media (min-width: 992px) {
    width: 129px;
    height: 129px;
  }
`;

const ActivateAcHolder = styled.div`
  padding: 40px 32px;
  max-width: 410px;
  margin: 0 auto;
  background: var(--bg-primary);
  border-radius: 20px;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  width: 100%;
`;
const BtnHolder = styled.div`
  display: flex;
  align-items: cneter;
  justify-content: space-between;
  padding: 15px 0;
  button {
    margin: 10px 5px;
  }
`;
const Wrapper = styled.div`
  min-height: 100vh;
  display: grid;
  place-items: center;
`;

export default function CheckEmail() {
  const { token } = useParams();
  const { user, setUser } = useContext(AuthContext);
  const history = useNavigate();
  const [email, setEmail] = useState('');
  // useEffect(() => {
  //   const decryptToken = async () => {
  //     const res = await userService.decryptToken(token);
  //     return res;
  //   };
  //   decryptToken().then(res => {
  //     setEmail(res.email);
  //   });
  // }, []);
  // const verifyEmail = async () => {
  //   const res = await userService.verifyEmail(token);
  //   Toast({
  //     type: 'success',
  //     message: res.message,
  //   });
  //   history('/');
  // };
  const verifyEmail = async () => {
    setUser(prev => ({ ...prev, is_email_verified: true }));
    Toast({
      type: 'success',
      message: 'your account is activated',
    });
    history('/');
  };

  return (
    <Wrapper>
      <ActivateAcHolder>
        <Logo white center />
        <IconHolder>
          <img src={MailIcon} alt="mail" />
        </IconHolder>
        <Heading level={1}>We’re glad you’re here</Heading>
        <Link as="span">{user.email}</Link>
        <BtnHolder>
          <Button sm type="primary" onClick={verifyEmail}>
            Activate Account
          </Button>
          <Button
            md
            type="primary"
            onClick={() => {
              history('/');
            }}>
            Logout
          </Button>
        </BtnHolder>
        <Paragraph noMargin>(Just confirming you’re you)</Paragraph>
      </ActivateAcHolder>
    </Wrapper>
  );
}
